'use client';

import { useCallback } from 'react';
import { useShallow } from 'zustand/shallow';
import { useGeo } from '../../../GeoProvider/hook';
import { useOffersFilterStore } from '../store/useOffersFilterStore';
import { DesktopFilters, type DesktopFiltersProps } from './index';

export const DesktopFiltersWithGeo: React.FC<DesktopFiltersProps> = props => {
  const { setRegionCode, initialRegionCode, regionCode, isReady } = useGeo();
  const { handleClearFiltersWithGeo } = useOffersFilterStore(
    useShallow(state => ({ handleClearFiltersWithGeo: state.handleClearFiltersWithGeo })),
  );

  const onClearFilters = useCallback(() => {
    handleClearFiltersWithGeo(initialRegionCode || 'CA', setRegionCode);
  }, [initialRegionCode, regionCode, handleClearFiltersWithGeo, setRegionCode]);

  return (
    <DesktopFilters
      {...props}
      onClearFilters={onClearFilters}
      initialClientRegion={initialRegionCode}
      showFilterSkeleton={!isReady}
      regionCode={regionCode}
    />
  );
};
